module.exports = __webpack_public_path__ + "media/images/tailwind/right-icon-16f40b9ed8d129585c17c2d8aceef0ed.png";